const BASE_API_URL = process.env.VUE_APP_BASE_API_URI;
const YY_BASE_API_URL = process.env.VUE_APP_YY_BASE_API_URI;


export default {
  CONTENT_URL: `${BASE_API_URL}/exam/contents/`, // /exam/contents/${content_key}
  SIMULATION_RECORD_URL: `${BASE_API_URL}/simulation/records/share/`, // /simulation/records/share/
  ITEMS_URL: `${YY_BASE_API_URL}/html5/items/list/`, // /html5/items/list/${category_id}
  ITEM_DETAIL_URL: `${YY_BASE_API_URL}/html5/items/`, // /html5/items/${item_id}
  SCORE_QUERY_URL: `${YY_BASE_API_URL}/html5/scorecheck`,
  TEACHER_PROFILE_URL: `${BASE_API_URL}/h5/tp/`, // /h5/tp/:code
  TEACHER_EXAM_DATA_URL: `${BASE_API_URL}/h5/tp/examdata/`, // h5/tp/examdata/:code
};
